import { useCallback, useMemo, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION_KEY, RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useDownloadCSV, useGetEmployerIdParam } from '../../hooks';
import { CardStatusReportTableParams } from '../CardStatusReport.types';

export const QUERY_KEY = 'EXPORT_CARD_STATUS_REPORT_CSV';
const useCardStatusReportExportCSVQuery = (params: CardStatusReportTableParams) => {
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);

  const formattedStartDate = useMemo(() => {
    if (!params.mailedStartDate) {
      return null;
    }
    const parsedDate = dayjs(params.mailedStartDate);
    if (!parsedDate.isValid()) {
      return null;
    }
    return parsedDate.format(RAW_DATE_FORMAT);
  }, [params.mailedStartDate]);

  const formattedEndDate = useMemo(() => {
    if (!params.mailedEndDate) {
      return null;
    }
    const parsedDate = dayjs(params.mailedEndDate);
    if (!parsedDate.isValid()) {
      return null;
    }
    return parsedDate.format(RAW_DATE_FORMAT);
  }, [params.mailedEndDate]);
  const getEmployerIdParam = useGetEmployerIdParam();
  const employerId = getEmployerIdParam(params.employerId, params.employerIds);
  const { refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(API_URL.REPORTS_CARD_STATUS_REPORT_BREAKDOWN_EXPORT_CSV, {
        params: _.pickBy({
          ...employerId,

          show_ssn: params.isSSNShowed,
          mailed_start_date: formattedStartDate,
          mailed_end_date: formattedEndDate,
          card_statuses:
            params?.cardStatuses && !params?.cardStatuses.includes(ALL_OPTION_KEY)
              ? params?.cardStatuses.join(',')
              : undefined,

          employment_statuses:
            params?.employmentStatuses && !params?.employmentStatuses.includes(ALL_OPTION_KEY)
              ? params?.employmentStatuses.join(',')
              : undefined,

          search_value: params.searchString,
        }),
      }),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response?.data?.data, 'csv', 'card-status_report');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    handleExport,
  };
};

export default useCardStatusReportExportCSVQuery;
